/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isFunction, isEqual, debounce } from 'lodash';
import UploadButton from 'shared/ui/components/uploader/UploadButton.vue';
import { addEventListener } from 'shared/libs/utils/helpers/dom';
import Draggable from 'vuedraggable';

const __vue_script__ = {
    name: 'VideoCallItemUploader',

    components: { UploadButton, Draggable },

    props: {
        videoCallId: {
            type: String,
            default: null
        },

        value: {
            type: Array,
            default: () => []
        },

        hasUnsavedChanges: {
            type: Boolean,
            default: false
        },

        attachmentSpecs: {
            type: Object,
            required: true
        },

        uploadButtonLabel: {
            type: String,
            default: 'Upload'
        },

        uploadModalTitle: {
            type: String,
            default: 'Upload'
        },

        uploadModalSubtitle: {
            type: String,
            default: null
        },

        uploadModalWarning: {
            type: String,
            default: null
        },

        fpType: {
            type: String,
            required: true
        },

        unsavedChangesText: {
            type: String,
            required: true
        },

        checkIsProcessing: {
            type: Function,
            default: () => false
        },

        getErrorInfoText: {
            type: Function,
            default: () => null
        },

        uploaderScope: {
            type: String,
            required: true
        },

        getItemsContent: {
            type: Function,
            required: true
        },

        removalConfirmationTitle: {
            type: String,
            required: true
        },

        removalConfirmationText: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            unsubscribers: [],
            itemsById: {},
            listExpanded: false,
            fetchItemsDebounced: debounce(() => this.fetchItems(), 1000)
        };
    },

    computed: {
        itemIds: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        },

        items() {
            return (this.itemIds ?? [])
                .map(id => this.itemsById[id])
                .filter(Boolean);
        }
    },

    watch: {
        itemIds: {
            immediate: true,
            handler(newVal, oldVal) {
                // Reordering should trigger an update, but since contents will be the same there's no need to re-fetch
                const containSameElements = newVal && oldVal && isEqual([...newVal].sort(), [...oldVal].sort());
                if (!containSameElements) {
                    this.fetchItems();
                }
            }
        }
    },

    async created() {
        this.unsubscribers.push(
            addEventListener(
                window,
                'uploader-done',
                ({ detail: { scope, id } }) => {
                    if (scope !== this.uploaderScope) {
                        return;
                    }
                    console.info(`[VideoCallItemUploader - ${this.fpType}] New upload`, id);
                    this.itemIds = [...this.itemIds, id];
                }
            ),
            await this.$services.signal.addSignalListener(
                `document/${this.fpType}/update`,
                ({ document }) => {
                    const id = document?.id;
                    console.info(`[VideoCallItemUploader - ${this.fpType}] Signal received about update`, { document, id });
                    // Debounce to avoid too many simultaneous requests if the user is uploading multiple files of roughly the same size
                    // (which can be processed at roughly the same time)
                    this.fetchItemsDebounced();
                }
            ),
            this.$services.signal.addEventListener('open', () => this.fetchItems())
        );
    },

    beforeDestroy() {
        for (const unsub of this.unsubscribers ?? []) {
            if (isFunction(unsub)) {
                unsub();
            }
        }
    },

    methods: {
        async fetchItems() {
            const items = await this.getItemsContent(this.itemIds);

            console.info(`[VideoCallItemUploader - ${this.fpType}] items fetched`, items);

            const indexed = {};
            for (const item of items ?? []) {
                indexed[item.id] = item;
            }
            this.itemsById = indexed;
        },

        removeItem(itemId) {
            if (this.itemIds && itemId) {
                this.$modal.show('dialog', {
                    title: this.removalConfirmationTitle,
                    text: this.removalConfirmationText,
                    buttons: [
                        {
                            title: this.$t('general.cancel'),
                            default: true,
                            class: 'btn'
                        },
                        {
                            title: this.$t('general.delete'),
                            handler: () => {
                                this.itemIds = this.itemIds.filter(id => id !== itemId);
                                this.$modal.hide('dialog');
                            },
                            class: 'btn btn-danger',
                            closeOnClick: true
                        }
                    ]
                });
            }
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "video-call-item-uploader" },
    [
      _c("upload-button", {
        attrs: {
          "attachment-specs": _vm.attachmentSpecs,
          scope: _vm.uploaderScope,
          label: _vm.uploadButtonLabel,
          "modal-title": _vm.uploadModalTitle,
          "modal-subtitle": _vm.uploadModalSubtitle,
          "modal-subtitle-as-html": true,
          "modal-warning": _vm.uploadModalWarning,
          "fp-type": _vm.fpType,
          "parent-doc-id": _vm.videoCallId,
        },
      }),
      _vm.hasUnsavedChanges
        ? _c("div", { staticClass: "alert alert-warning" }, [
            _vm._v(_vm._s(_vm.unsavedChangesText)),
          ])
        : _vm._e(),
      _c(
        "draggable",
        {
          staticClass: "existing-items",
          attrs: { handle: ".drag-handle" },
          model: {
            value: _vm.itemIds,
            callback: function ($$v) {
              _vm.itemIds = $$v
            },
            expression: "itemIds",
          },
        },
        _vm._l(_vm.items, function (item, index) {
          return _c(
            "div",
            {
              key: item.id,
              staticClass: "item",
              class: { hidden: !_vm.listExpanded && index >= 4 },
            },
            [
              _c("div", { staticClass: "drag-handle" }, [
                _c("i", { staticClass: "icon-reorder" }),
              ]),
              _c(
                "div",
                { staticClass: "title", class: { "title-error": item.error } },
                [_vm._v(_vm._s(item.title))]
              ),
              _c("div", { staticClass: "actions" }, [
                _vm.checkIsProcessing(item)
                  ? _c("div", { staticClass: "badge" }, [
                      _vm._v(_vm._s(_vm.$t("contents.detail.processing"))),
                    ])
                  : item.error
                  ? _c("div", { staticClass: "badge badge-danger" }, [
                      _vm._v(
                        _vm._s(_vm.$t("generic_form.video.uploader_item_error"))
                      ),
                      _vm.getErrorInfoText(item.error)
                        ? _c("i", {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.getErrorInfoText(item.error),
                                expression: "getErrorInfoText(item.error)",
                              },
                            ],
                            staticClass: "tip ic-info-fill",
                          })
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _c("i", {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip.top",
                      value: _vm.$t("general.delete"),
                      expression: "$t('general.delete')",
                      modifiers: { top: true },
                    },
                  ],
                  staticClass: "ic-trash-2 remove",
                  on: {
                    click: function ($event) {
                      return _vm.removeItem(item.id)
                    },
                  },
                }),
              ]),
            ]
          )
        }),
        0
      ),
      _vm.itemIds && _vm.itemIds.length > 4
        ? _c(
            "a",
            {
              staticClass: "full-list-toggler",
              on: {
                click: function ($event) {
                  _vm.listExpanded = !_vm.listExpanded
                },
              },
            },
            [
              _vm._v(
                _vm._s(
                  _vm.listExpanded
                    ? _vm.$t("general.show_less")
                    : _vm.$t("general.show_more")
                )
              ),
              _c("i", {
                class: {
                  "ic-chevron-down": !_vm.listExpanded,
                  "ic-chevron-up": _vm.listExpanded,
                },
              }),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/form-components/VideoCallItemUploader.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__